import bannerAnimationData from "../animations/common_main_banner_lottie/Service_banner_lottie.json";
import Common_main_banner from '../common_components/common_banner/common_main_banner/Common_main_banner';
import Bill_payments from '../home/bill_payments/Bill_payments';
import Contribution from '../home/contribution/Contribution';
import Recharge_now from '../home/recharge_now/Recharge_now';
import Rewards from './rewards/Rewards';

function Services() {
    // ✅ Banner slides data
    const bannerSlides = [
        {
            heading: "ONE PLATFORM. ALL YOUR PAYMENTS.",
            subheading: "Mobile, DTH, Electricity, Gas booking, or Fastag — We’ve Got You Covered."
        },
        {
            heading: "MANAGE YOUR TRANSACTIONS EASILY.",
            subheading: "Track all payments, bills, and services from a single dashboard."
        },
        {
            heading: "SECURE AND FAST PAYMENTS.",
            subheading: "Enjoy seamless and secure digital transactions with complete peace of mind."
        },
        {
            heading: "RECHARGE, PAY & EARN REWARDS.",
            subheading: "Make every transaction rewarding with exclusive cashback and offers."
        }
    ];

    // ✅ Services data
    const services = [
        {
            id: 1,
            img: "/assets/images/home/bill_payments/money.png",
            title: "Mobile Recharge",
            baseLink: "/mobile-recharge",
        },
        {
            id: 2,
            img: "/assets/images/home/bill_payments/satellite-dish.png",
            title: "DTH Recharge",
            baseLink: "/dth-recharge",
        },
        {
            id: 3,
            img: "/assets/images/home/bill_payments/light-bulb.png",
            title: "Electricity Bill",
            baseLink: "/electricity-recharge",
        },
        {
            id: 4,
            img: "/assets/images/home/bill_payments/gas-stove.png",
            title: "Gas Cylinder",
            baseLink: "/gas-recharge",
        },
        {
            id: 5,
            img: "/assets/images/home/bill_payments/buy-a-car.png",
            title: "FASTag Recharges",
            baseLink: "/fastag-recharge",
        },
    ];

    return (
        <>
            {/* ✅ Common Banner */}
            <Common_main_banner
                animationData={bannerAnimationData}
                slides={bannerSlides}
            />

            {/* ✅ Bill Payments Section */}
            <Bill_payments
                services={services}
                sectionTitle="SEAMLESS BILL PAYMENTS & RECHARGES"
                sectionSubtitle="Recharge instantly, pay bills securely, and enjoy a hassle-free experience."
            />

            {/* ✅ Other Home Components */}
            <Recharge_now />
            <Rewards/>
            <Contribution />
        </>
    );
}

export default Services;
